import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Select, MenuItem, FormControl, InputLabel, CircularProgress, Typography
} from '@mui/material';
import axios from 'axios';

const AddToAnomalyListModal = ({ open, onClose, gameId }) => {
    const [lists, setLists] = useState([]);
    const [selectedList, setSelectedList] = useState('');
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (open) {
            fetchLists();
        }
    }, [open]);

    const fetchLists = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/anomaly-review/lists`, {
                headers: { 'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY }
            });
            setLists(res.data);
            
            // Default to 'Global List' if it exists, else the first one
            const globalList = res.data.find(l => l.Name.toLowerCase().includes('global'));
            if (globalList) {
                setSelectedList(globalList.ListID);
            } else if (res.data.length > 0) {
                setSelectedList(res.data[0].ListID);
            }
        } catch (err) {
            console.error('Failed to fetch lists', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        if (!selectedList || !gameId) return;
        try {
            setSaving(true);
            await axios.post(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/anomaly-review/lists/${selectedList}/games`, 
                { GameIDs: [gameId] },
                { headers: { 'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY } }
            );
            onClose();
            alert('Game added to anomaly list!');
        } catch (err) {
            console.error('Failed to add to list', err);
            alert('Failed to add game to anomaly list.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Send Game to Anomaly Review List</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Flag game <strong>{gameId}</strong> for further review.
                </Typography>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <FormControl fullWidth>
                        <InputLabel>Review List</InputLabel>
                        <Select
                            value={selectedList}
                            label="Review List"
                            onChange={(e) => setSelectedList(e.target.value)}
                        >
                            {lists.map(list => {
                                const isSmart = list.Type === 'SmartStudio' || (list.StudioIDs && list.StudioIDs.length > 0);
                                return (
                                    <MenuItem key={list.ListID} value={list.ListID}>
                                        {list.Name} {isSmart && <Typography component="span" variant="body2" color="textSecondary" sx={{ ml: 1 }}>(Smart List)</Typography>}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained" disabled={saving || !selectedList}>
                    {saving ? 'Adding...' : 'Add to List'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddToAnomalyListModal;
